<!--
 * @Descripttion: 弹窗扩展组件
 * @Program: django-vue-lyadmin
 * @version: 1.4
 * @Author: lybbn
 * @Date: 2023年04月11日
 * @EditDate: 2024年07月11日
-->
<template>
  <div class="ly-dialog" :style="{ '--fullScreenBodyPadding': fullScreenBodyPadding }">
    <el-dialog
      v-model="visible"
      :close-on-click-modal="closeOnClickModal"
      :title="title"
      :width="width"
      :top="top"
      :fullscreen="screeFull"
      :center="center"
      :before-close="beforeClose"
      :append-to-body="appendToBody"
      :destroy-on-close="true"
      :draggable="draggable"
      :show-close="showClose"
      @closed="closed"
      ref="lydialog"
      @opened="handleOpened(screeFull)">
      <template #header="{ close, titleId, titleClass }">
        <div>
          <slot name="header">
            <span :id="titleId" :class="titleClass">{{ title }}</span>
          </slot>
          <slot name="headerCenter"></slot>
          <div class="ly-dialog__headerbtn">
            <button aria-label="fullscreen" type="button" @click="handleFullScreenClick" v-if="showFullscreen">
              <el-icon v-if="screeFull" class="el-dialog__close"><Minus /></el-icon>
              <el-icon v-else class="el-dialog__close"><full-screen /></el-icon>
            </button>
            <button aria-label="close" type="button" @click="close">
              <el-icon class="el-dialog__close"><close /></el-icon>
            </button>
          </div>
        </div>
      </template>
      <div v-loading="loading">
        <slot></slot>
      </div>
      <template v-if="$slots.footer" #footer>
        <slot name="footer"></slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
    import 'element-plus/es/components/dialog/style/css'
    export default {
        name: 'LyDialog',
        data(){
            return{
                visible:false,
                screeFull:false
            }
        },
        props: {
            title: {
              type: String,
              default: ''
            },
            modelValue: {
              type: Boolean,
              default: true
            },
            width: {
              type: String,
              default: '50%'
            },
            height: {
              type: String,
              default: ''//为空则非全屏状态下自动给出最大高度，有值则按设置的值设置el-dialog__body的高度,100%表示不设置高度
            },
            center: {
              type: Boolean,
              default: false
            },
            top: {
              type: String,
              default: '40px'
            },
            draggable: {
              type: Boolean,
              default: true
            },
            appendToBody: {
              type: Boolean,
              default: false
            },
            closeOnClickModal: {
              type: Boolean,
              default: false
            },
            fullscreen: {
              type: Boolean,
              default: false
            },
            showClose: {
              type: Boolean,
              default: false
            },
            showFullscreen: {
              type: Boolean,
              default: true
            },
            fullScreenBodyPadding:{
              type:[String,Number],
              default:"20px"
            },//全屏时body的padding值
            loading: {
              type: Boolean,
              default: false
            },
            beforeClose:Function// 关闭回调函数
        },
        watch:{
            modelValue: function(nval){
                this.visible = nval; // modelValue改变是同步子组件visible的值
            },
            fullscreen:function(nval) {
                this.screeFull = nval
            },
            screeFull: function(nval) {
                this.$emit('update:fullscreen', nval); // visible改变时同步父组件modelValue的值
                this.handleOpened(this.screeFull)
            }
        },
        mounted() {
            this.screeFull = this.fullscreen
            this.visible = this.modelValue
        },
        methods:{
            openDialog() {
                this.visible = true
            },
            closeDialog() {
                this.visible = false
            },
            closed() {
                this.$emit('closed')
            },
            handleFullScreenClick(){
                this.screeFull = !this.screeFull
            },
            calcBodyHeight(fullscreen=false){
              if(!fullscreen && !!this.$refs.lydialog.dialogContentRef){
                    const dialogBody = this.$refs.lydialog.dialogContentRef.$el.querySelector(".el-dialog__body")
                    // 获取 Dialog 的标题栏和底部按钮栏
                    const headerbody = this.$refs.lydialog.dialogContentRef.$el.querySelector(".el-dialog__header")
                    const footerbody = this.$refs.lydialog.dialogContentRef.$el.querySelector(".el-dialog__footer")
                    const headerHeight = headerbody?headerbody.offsetHeight:0;
                    const footerHeight = footerbody?footerbody.offsetHeight:0;
                    // 计算 Dialog 内容区域的最大高度
                    const maxHeight = `calc(100vh - ${headerHeight + footerHeight}px - 100px - ${this.top})`;
                    this.$nextTick(() => {
                      // 设置 Dialog 内容区域的最大高度
                      if(!!this.height){
                        dialogBody.style.maxHeight = this.height;
                      }else{
                        dialogBody.style.maxHeight = maxHeight;
                      }
                    })
                }
            },
            handleOpened(fullscreen=false) {
              this.calcBodyHeight(fullscreen)
            },
        }
    }
</script>

<style scoped>
  .ly-dialog__headerbtn {
      position: absolute;
      top: var(--el-dialog-padding-primary);
      right: var(--el-dialog-padding-primary);
  }
  .ly-dialog__headerbtn button {
      padding: 0;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
      font-size: var(--el-message-close-size,16px);
      margin-left: 15px;
      color: var(--el-color-info);
  }
  .ly-dialog__headerbtn button:hover .el-dialog__close {
      color: var(--el-color-primary);
  }
  .ly-dialog:deep(.el-dialog) {
      padding: 0 !important;
  }
  .ly-dialog:deep(.el-dialog) .el-dialog__body {
      max-height: 100%;
      overflow-y: auto;
      transition: max-height 0.3s linear; /* 添加过渡效果 */
      overflow-x: hidden;
      padding: var(--el-dialog-padding-primary);
  }
  .ly-dialog:deep(.el-dialog) .el-dialog__header {
      padding: var(--el-dialog-padding-primary);
  }
  .ly-dialog:deep(.el-dialog) .el-dialog__footer {
      padding: var(--el-dialog-padding-primary);
  }
  .ly-dialog:deep(.el-dialog).is-fullscreen {
      display: flex;
      flex-direction: column;
      top:0px !important;
      left:0px !important;
      padding: 0 !important;
  }
  .ly-dialog:deep(.el-dialog).is-fullscreen .el-dialog__header {
      border-bottom:var(--el-border);
      margin-right:0 !important;
      padding: 20px;
  }
  .ly-dialog:deep(.el-dialog).is-fullscreen .el-dialog__body {
      flex:1;
      overflow: auto;
      max-height: 100% !important;
      padding: var(--fullScreenBodyPadding);
  }
  .ly-dialog:deep(.el-dialog).is-fullscreen .el-dialog__footer {
      padding-bottom: 10px;
      border-top:var(--el-border);
      padding-left: 20px;
      padding-right: 20px;
  }
</style>